import { TFunction } from 'i18next';
import { ButtonVariants } from 'shared/components/ui/popup-menu';
import { FilterDocuments } from 'shared/constants';
import { FilterGroup, FilterOptionType } from 'shared/types/filter';

export type Options = { t: TFunction };

export const createResetFilterDocumentGroup = ({
  t,
}: Options): FilterGroup[] => [
  {
    id: FilterDocuments.ResetFilterDocumentID,
    filters: [
      {
        id: FilterDocuments.ResetFilterDocumentID,
        label: t('context-menus.filtering.task.filters.clear.label'),
        type: FilterOptionType.Button,
        buttonVariant: ButtonVariants.Error,
      },
    ],
  },
];
